<ngx-spinner name="sp" [fullScreen]="true" type="ball-clip-rotate-multiple" size="medium"></ngx-spinner>
<nav id="navLg" class="navbar navbarCustom">
  <div class="p-grid w-100">
    <div class="p-col">
      <img src="./assets/Imagenes/logoFinmeridian.png" class="imgAppBar">
    </div>
    <div class="p-col colMenu">
      <i class="fa fa-home iconoNav" aria-hidden="true"></i>
      <p class="txtNav" (click)="navegarRuta('/cliente/home')">Inicio</p>
    </div>
    <div class="p-col colMenu">
      <p class="txtNav" (click)="navegarRuta('/cliente/mis-solicitudes')">Mis Solicitudes</p>
    </div>
    <div class="p-col colMenu">
      <p class="txtNav" (click)="navegarRuta('/cliente/cambioClave')">Contraseñas</p>
    </div>
    <!-- <div class="p-col colMenu" (click)="navegarRuta('/cliente/solicitudCredito/tipoCredito')">
      <p class="txtNav" >Solicitar</p>
    </div> -->
    <div class="p-col colMenu">
      <p class="txtNav" (click)="navegarRuta('/cliente/info-cuenta')">Mi cuenta</p>
    </div>
    <div class="p-col colMenu" >
      <i class="fa fa-bell iconNotifi" aria-hidden="true"></i>
      <table>
        <tr>
          <a class="txtNav">{{nomCliente}}</a>
        </tr>
        <tr>
          <a class="cerrarSesion" (click)="cerrarSesion()">Cerrar sesión</a>
        </tr>
      </table>
      <i class="fa fa-user-circle iconoUser" aria-hidden="true" ></i>
    </div>
  </div>
</nav>


<nav id="navSM" class="navbar">
  <div class="p-grid">
    <div class="p-col" (click)="abrirMenu()">
      <i class="fa fa-list iconMenuSm" aria-hidden="true"></i>
      <img src="./assets/Imagenes/logoFinmeridian.png" class="imgAppBar">
    </div>
  </div>

  <p-sidebar [(visible)]="menusm" position="left" [baseZIndex]="10000">
    <p class="txtTituloMenu">Escoja una opción</p>
    <div class="itemMenu" (click)="navegarRuta('/cliente/home')">
      <p class="txtItemMenu">Inicio</p>
    </div>
    <div class="itemMenu">
      <p class="txtItemMenu" (click)="navegarRuta('/cliente/mis-solicitudes')">Mis solicitudes</p>
    </div>
    <!-- <div class="itemMenu" (click)="navegarRuta('/cliente/solicitudCredito/tipoCredito')">
      <p class="txtItemMenu">Solicitar</p>
    </div> -->
    <div class="itemMenu" (click)="navegarRuta('/cliente/info-cuenta')">
      <p class="txtItemMenu">Mi cuenta</p>
    </div>
    <div class="itemMenu" (click)="navegarRuta('/home/restablecerPass')">
      <p class="txtItemMenu">Usuario 1</p>
    </div>
  </p-sidebar>

</nav>
